export enum LabelTypeEnum {
  VERIFIED = 'verified',
  UNDER_VERIFICATION = 'under verification',
  OPEN = 'open',
  CLOSED = 'closed',
  DRAFT = 'draft',
  ARCHIVE = 'archive',
}
